export enum FormState {
  confirm = 'Confirm',
  success = 'Success',
  failure = 'Failure',
  submitting = 'Submitting',
}
